import UrlHelpers from "./url";
import {i18n} from "./i18n";
import {addIcon} from "./icons";
import {FieldHandler} from "./fieldHandler";
import {app_created, app_edit_changed_saved, app_edit_deleted, app_edit_provider_changed} from "./dapiEventUris";
import {setContextActions} from "./contextActions";
import {ErrorHandler} from "./errorHandler";

export class AppList {
    private _dapi: Dapi = (<any>window).dapi;
    private _dux = (<any>window).dux;
    private _i18n: i18n = new i18n();
    private _providerCtx:boolean = UrlHelpers.getMetaData('providerCtx') === "1";

    constructor(){
        this._addCtxActions();
        this._createBtnCreateApp();
        this._addAppNameCounter();
        this._dapi.addResourceEventListener('changed', this._dapiEvent);
        this._dapi.addResourceEventListener('deleted', this._dapiEvent);
        if(this._dapi.isMainResource()) {
            this._dapi.publishLocation(location.href);
        }
    }

    private _dapiEvent = (resourceEvent: IResourceEvent):void => {
        if((resourceEvent.uri === app_edit_changed_saved && resourceEvent.name==='changed') ||
            (resourceEvent.uri === app_edit_deleted && resourceEvent.name==='deleted') ||
            (resourceEvent.uri === app_created && resourceEvent.name==='changed') ||
            (resourceEvent.uri === app_edit_provider_changed && resourceEvent.name==='changed'))
        {
            location.reload(true);
        }
    };

    private _addCtxActions = () => {
        if(this._providerCtx) {
            const ctx = new Array<IContextAction>();
            ctx.push({
                title: this._i18n.getTranslation('app_list_ctx_actions_btn_createapp_label'),//"Neue App erstellen",
                icon: addIcon,
                callback: () => {
                    this._createAppDialogShow();
                }
            });
            // this._dapi.setContextActions(ctx);
            setContextActions(this._dapi, this._i18n, ctx);
        }
    };

    private _createAppDialogShow = () => {
        if(this._providerCtx) {
            this._dux.query('#modalCreateApp').modal('toggle');
        }
    };

    private _createBtnCreateApp = () => {
        if(this._providerCtx) {
            const btn = document.getElementById('btnCreate');
            if (btn) {
                (<HTMLButtonElement>btn).addEventListener('click', this._createAppClick);
                this._dux.query('#modalCreateApp').on('hide.bs.modal', () => {
                    (<HTMLInputElement>document.getElementById('txtAppName')).value = "";
                });
            }
        }
    };

    private _addAppNameCounter = () => {
        if (this._providerCtx) {
            const appNameInput = <HTMLInputElement>document.getElementById('txtAppName');
            if(appNameInput){
                this._setAppNameCounter(appNameInput);
                appNameInput.addEventListener('keyup', this._appNameCounterEvent);
            }
        }
    }

    private _appNameCounterEvent = (e:Event) => {
        if (this._providerCtx){
            const current = <HTMLInputElement>e.currentTarget;
            if(current){
                this._setAppNameCounter(current);
            }
        }
    }

    private _setAppNameCounter = (input:HTMLInputElement) => {
        const counterSpan = <HTMLSpanElement>document.getElementById('txtAppNameCounter');
        counterSpan.innerText = input.value.length.toString();
    }

    private _createAppClick = () => {
        if(this._providerCtx) {
            const name = FieldHandler.getFieldValue('txtAppName');
            if (!this._isAppNameValid(name)) {
                return
            }

            const provider = UrlHelpers.getQueryParameter(window.location.href, 'provider');
            const data = JSON.stringify({
                appName: name,
                provider: provider
            });
            const url = UrlHelpers.getLinkRelHref('self');
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.setRequestHeader('accept', 'application/json');
            xhr.onload = () => {
                if (xhr.status === 201) {
                    this._dux.query('#modalCreateApp').modal('hide');
                    const targetUri = xhr.getResponseHeader('location');
                    this._dapi.dispatchResourceEvent({
                        name: 'changed',
                        uri: app_created
                    });
                    this._dapi.navigate(targetUri);
                } else if (xhr.status === 409) {
                    const error = ErrorHandler.parseError(xhr.responseText);
                    const desc = error.description.trim().toLowerCase();

                    let msg = "wrong message found: " + desc;

                    if (desc == "an app with this name does already exist") {
                        const inputField = <HTMLInputElement>document.getElementById('txtAppName');
                        const prefix = inputField.dataset["prefix"];
                        msg = this._i18n.getTranslation('app_list_modal_createapp_error_appname_exists_message');
                        msg = i18n.replaceTranslationPlaceholder(msg,"{appName}", `${prefix}-${name}`);
                    } else if(desc == "app name is invalid") {
                        msg = this._i18n.getTranslation('app_list_modal_createapp_error_appname_invalid_message');
                    } else if(desc == "app name is blacklisted") {
                        msg = this._i18n.getTranslation('app_list_modal_createapp_error_appname_blacklisted_message');
                    }

                    FieldHandler.setFieldError('txtAppName_',msg);
                    console.warn(xhr.responseText);
                } else {
                    FieldHandler.setFieldError('txtAppName_', this._i18n.getTranslation('app_list_modal_createapp_error_unknownerror_message'));
                    console.error(xhr.responseText);
                }
            };
            try {
                xhr.send(data);
            } catch (exp) {
                console.error(exp);
            }
        }
    };

    private _isAppNameValid = (name:string):boolean => {
        if (name.isNullOrEmpty()) {
            FieldHandler.setFieldError('txtAppName_', this._i18n.getTranslation('app_list_modal_createapp_error_appname_empty_message'));
            console.error("no appName found!");
            return false;
        }
        const textField = document.getElementById('txtAppName');
        const strMaxLength = textField.getAttribute('maxlength');
        const maxLength = +strMaxLength;
        if (maxLength < name.length) {
            FieldHandler.setFieldError('txtAppName_', this._i18n.getTranslation('app_list_modal_createapp_error_appname_out_of_bound_message'))
            console.error(`length of app name cannot be greater than ${maxLength}. App name length was ${name.length}`);
            return false;
        }
        return true;
    }
}